import { h, render } from 'preact';
import AutoPlayVideo from '../media/AutoPlayVideo';

export default (element, data) => {
  const init = () => {
    render(<VideoSection />, element);
  };

  const VideoSection = () => (
    <AutoPlayVideo 
      mobileVideo={data.video_mobile} 
      desktopVideo={data.video_desktop} 
      controls={data.controls}
       />
  )

  init();
};